{
  "heading": "Modules",
  "newModule": "Nouveau module",
  "emptyTitle": "Aucun module pour l'instant",
  "emptyMessage": "Créez un module de formation pour commencer.",
  "retry": "Réessayer",
  "unknownCampus": "Campus inconnu",
  "unknownCategory": "Catégorie inconnue"
}
